import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=1bb163f0&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=1bb163f0&prod&lang=scss&scoped=true"
import style1 from "./LanguagePicker.vue?vue&type=style&index=1&id=1bb163f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb163f0",
  null
  
)

export default component.exports